import { Box, Grid, GridSize, Typography } from "@mui/material";
import {
  FieldValue,
  ItemIconBox,
  LowerContainer,
  AddressMemberInfoField,
  PatientDetailsValue,
  patientNameContainer,
} from "../style";
import { PatientNameGrid } from "./MemberInfo";
import {
  displayFlex,
  flexAlignCentre,
} from "../../../styles/mui/styles/display";
import { onlyAlphabets } from "../../../constants/Patterns";
import fontWeight from "../../../styles/mui/fontWeight";
import colors from "../../../styles/colors/colors";
import { PatientHeaderFormProps } from ".";


const AddressInfo: React.FC<PatientHeaderFormProps> = ({ getValues }: PatientHeaderFormProps) => {
  const addressFieldRender = (label: string, value: string) => {
    return (
      <Grid container>
        <Grid size={12} sx={flexAlignCentre}>
          <Typography
            variant="subtitle2"
            fontWeight={fontWeight.Weight[3]}
            color={colors.fonts[5]}
            mt={"0.2rem"}
          >
            {label}:
          </Typography>
        </Grid>
        <Typography
          variant="subtitle2"
          fontWeight={fontWeight.Weight[5]}
          color={colors.fonts[4]}
          sx={FieldValue}
        >
          {value}
        </Typography>
      </Grid>
    );
  };

  const fieldRender = (
    label: string,
    xs: GridSize,
    value: string | null | undefined,
    icon?: React.ReactElement
  ) => {
    return (
      <Grid size={xs} sx={AddressMemberInfoField}>
        <Typography
          variant="body1"
          fontWeight={fontWeight.Weight[3]}
          color={colors.fonts[2]}
        >
          {label}
        </Typography>
        <Box sx={displayFlex}>
          {icon && value ? <Box sx={ItemIconBox}>{icon}</Box> : ""}
          <Typography
            variant="subtitle2"
            fontWeight={fontWeight.Weight[5]}
            color={colors.fonts[4]}
            sx={PatientDetailsValue}
          >
            {value}
          </Typography>
        </Box>
      </Grid>
    );
  };

  return (
    <Grid container wrap="nowrap" columnSpacing={0.5}>
      <Grid size="auto" sx={patientNameContainer}>
        {PatientNameGrid(getValues("patientName"))}
      </Grid>
      <Grid size="grow">
        <Grid container size={"grow"}>
          <Grid size={12}>
            <Grid container>
              {fieldRender("Phone:", 1.5, getValues("memberInfo.phoneNo"))}
              {fieldRender(
                "Mobile Phone:",
                1.5,
                getValues("memberInfo.cellPhone")
              )}
              {fieldRender(
                "Alt Phone:",
                1.5,
                getValues("memberInfo.alternatePhone")
              )}
            </Grid>
          </Grid>
          <Grid size={12} sx={LowerContainer}>
            <Grid container pt={"0.5rem"} gap={"3rem"}>
              <Grid size={4.5}>
                {addressFieldRender(
                  "Residential Address",
                  onlyAlphabets.test(
                    getValues("addressInfo.residentialAddress")
                  )
                    ? getValues("addressInfo.residentialAddress")
                    : ""
                )}
              </Grid>
              <Grid size={4.5} >
                {addressFieldRender(
                  "Mailing Address",
                  onlyAlphabets.test(getValues("addressInfo.mailingAddress"))
                    ? getValues("addressInfo.mailingAddress")
                    : ""
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddressInfo;
